/* istanbul ignore file */
import Step4 from './Step4'
import { connect } from 'react-redux'
import { isUserLoadedSelector, userDataSelector } from '../../selectors/user'
import { driverDataSelector } from '../../selectors/driver'
import { updateDriver } from '../../actions/driver'
import { publicTokenDataSelector, oAuthTokenDataSelector } from '../../selectors/token'
import { bookingDataSelector } from '../../selectors/booking'
import { rentalCarContractIsLoadingSelector, rentalCarContractLoadedSelector } from '../../selectors/rentalCarContract'
import { reload } from '../../actions/navigation'
function mapStateToProps (state) {
    const booking = bookingDataSelector(state)
    return {
        userLoaded: isUserLoadedSelector(state),
        user: userDataSelector(state),
        driver: driverDataSelector(state),
        publicToken: publicTokenDataSelector(state),
        oAuthToken: oAuthTokenDataSelector(state),
        uuid: booking.uuid,
        id: booking.id,
        loading: rentalCarContractIsLoadingSelector(state) || rentalCarContractLoadedSelector(state),
    }
}

export default connect(mapStateToProps, {
    updateDriver,
    reload,
})(Step4)
